import { Microfrontend } from '@thoughtspot/microfrontends';
import React from 'react';
import { loadMicroFrontendComponent } from './microfrontend-wrapper';
import {
    getMicroFrontendComponent,
    initMicroFrontend,
} from './microfrontends.util';

enum GlobalNavComponents {
    TopNav = 'TopNav',
    OrgMenuContainer = 'OrgMenuContainer',
    TopNavV3 = 'TopNavV3',
    LearningModuleContainer = 'LearningModuleContainer',
}

export const TopNav = loadMicroFrontendComponent(
    Microfrontend.GLOBAL_NAV,
    GlobalNavComponents.TopNav,
);

export const OrgMenuContainer = loadMicroFrontendComponent(
    Microfrontend.GLOBAL_NAV,
    GlobalNavComponents.OrgMenuContainer,
);

export const TopNavV3 = loadMicroFrontendComponent(
    Microfrontend.GLOBAL_NAV,
    GlobalNavComponents.TopNavV3,
);

export const LearningModuleContainer = loadMicroFrontendComponent(
    Microfrontend.GLOBAL_NAV,
    GlobalNavComponents.LearningModuleContainer,
);

initMicroFrontend(Microfrontend.GLOBAL_NAV);
